import React, { useRef } from 'react';
import JoditEditor from 'jodit-react';

const JoditEditorComponent = ({ field, form }) => {
  const editor = useRef(null);
  const config = {
    readonly: false, 
    height: 100, 
  };
  const handleChange = (newContent) => {
    if (newContent !== field.value) {
      form.setFieldValue(field.name, newContent);
    }
  };
  return (
    <JoditEditor
      ref={editor}
      value={field.value}
      config={config}
      tabIndex={1}
      onBlur={handleChange}
    />
  );
};

export default JoditEditorComponent;
